import { SelectionModel } from "@angular/cdk/collections";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource, MatSort, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { ResizedEvent } from "angular-resize-event";
import {
  SearchFilter,
  IFilterResponse,
} from "src/app/infrastructure/iFilter-component";
import { AdmissionSearchItem } from "src/app/model/admission-search-item";
import { MedicalAppointmentCancel } from "src/app/model/medical-appointment-cancel";
import { AdmissionService } from "src/app/services/admission.service";
import { AuthService } from "src/app/services/auth.service";
import { EnvironmentPresetService } from "src/app/services/environment-preset/environment-preset.service";
import { MenuService } from "src/app/services/menu.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { LogViewDialogComponent } from "../../dialogs/log-view/log-view-dialog.component";
import { DialogCancelMedicalAppointmentComponent } from "../../dialogs/medical-appointment-cancel/dialog-medical-appointment-cancel.component";
import { MedicalAppointmenChangeDateDialogComponent } from "../../dialogs/medical-appointment-change-date/medical-appointment-change-date-dialog.component";
import { MedicalAppointmenObservationDialogComponent } from "../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component";
import { SearchFilterComponent } from "../../search-filter/search-filter.component";
import { LaboratoryAppointmentQuestionDialogComponent } from "../../dialogs/laboratory-appointment-question-dialog/laboratory-appointment-question-dialog.component";
import { LaboratoryAppointmentQuestionService } from "src/app/services/laboratory-appointment-question/laboratory-appointment-question.service";

@Component({
  selector: "app-admission-integrated-search",
  templateUrl: "./admission-integrated-search.component.html",
  styleUrls: ["./admission-integrated-search.component.css"],
})
export class AdmissionIntegratedSearchComponent {
  canCancelAdmited: boolean;
  canChangeAppointmentDate: boolean;
  loaded: boolean;
  loadingAction: boolean;
  loadingMasiveAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;
  displayedColumns: string[] = [
    "Select",
    "date",
    "receptionDate",
    "stateName",
    "isOverAppointment",
    "isReAppointmentYesNo",
    "patientLasNameFirstName",
    "protocol",
    "practiceRegionName",
    "equipmentName",
    "physicianLastNameFirstName",
    "entityName",
    "star",
  ];

  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<AdmissionSearchItem>(true, []);
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private notificationToastService: NotificationToastService,
    private admissionService: AdmissionService,
    private authService: AuthService,
    private laboratoryAppointmentQuestionService: LaboratoryAppointmentQuestionService,
    private menuService: MenuService,
  ) {
    this.menuService.setMenuTitle("Admisión", "consulta integrada");
    this.canCancelAdmited = this.authService.canCancelAdmited();
    this.canChangeAppointmentDate = this.authService.canChangeAppointmentDate();
  }

  isAllSelected() {
    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.pager.getAllItems().forEach((row) => this.selection.select(row));
  }

  resizeColumn() {}

  onStartSearch() {}

  async openLaboratoryAppointmentQuestionDialog(
    admissionSearchItem: AdmissionSearchItem,
  ) {
    const questions =
      await this.laboratoryAppointmentQuestionService.getByAppointment(
        admissionSearchItem.MedicalAppointmentId,
      );

    if (questions && questions.length > 0) {
      const dialogRef = this.dialog.open(
        LaboratoryAppointmentQuestionDialogComponent,
        {
          width: "1000px",
          maxHeight: "90vh",
          disableClose: true,
          data: questions,
        },
      );
    }
  }

  changeAppointmentDate(admissionSearchItem: AdmissionSearchItem) {
    const dialogRef = this.dialog.open(
      MedicalAppointmenChangeDateDialogComponent,
      {
        width: "50%",
        data: {},
      },
    );

    dialogRef.afterClosed().subscribe(async (date: Date) => {
      if (date) {
        try {
          await this.admissionService.changeAppointmentDate(
            admissionSearchItem.MedicalAppointmentId,
            date,
          );
          this.searchFilter.search();
        } catch (err) {
          this.notificationToastService.error(
            JSON.stringify(err.error),
            "Admisión",
          );
        } finally {
          this.loadingMasiveAction = false;
        }
      }
    });
  }

  assignMedicalAppointment(admissionSearchItem: AdmissionSearchItem) {
    this.router.navigate([
      "reservation-wizard",
      "true",
      admissionSearchItem.MedicalAppointmentId,
      "admission-search",
    ]);
  }

  async patientAdmission() {}

  onTableResized(event: ResizedEvent): void {
    this.widthTableExp = event.newWidth - 40;
  }

  onResizing() {}

  openMedicalAppointmentObservationDialog(
    admissionSearchItem: AdmissionSearchItem,
  ): void {
    const dialogRef = this.dialog.open(
      MedicalAppointmenObservationDialogComponent,
      {
        width: "50%",
        data: {
          medicalAppointmentId: admissionSearchItem.MedicalAppointmentId,
          editLastObservation: true,
        },
      },
    );
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loaded = true;
  }

  onEndSearch(response: IFilterResponse<AdmissionSearchItem>) {
    this.pager.setItems(response.items);
    this.searchFilters = response.searchFilters;
    this.selection = new SelectionModel<AdmissionSearchItem>(true, []);
  }

  applyFilter() {}

  async rollBackControled() {
    try {
      let items = this.selection.selected;
      if (items.length > 0) {
        this.loadingMasiveAction = true;
        let studyReports = this.selection.selected;
        await this.admissionService.rollBackAdmissionControled(
          studyReports.map((s) => s.MedicalAppointmentId),
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión",
      );
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async controled() {
    try {
      let items = this.selection.selected;
      if (items.length > 0) {
        this.loadingMasiveAction = true;
        let studyReports = this.selection.selected;
        await this.admissionService.setAdmissionControled(
          studyReports.map((s) => s.MedicalAppointmentId),
        );
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión",
      );
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async admissionEdit(admissionSearchItem: AdmissionSearchItem) {
    this.router.navigate([
      "integrated-control-admission",
      admissionSearchItem.Atention,
      admissionSearchItem.PatientId,
      "false",
    ]);
  }

  async admissionView(admissionSearchItem: AdmissionSearchItem) {
    this.router.navigate([
      "integrated-control-admission",
      admissionSearchItem.Atention,
      admissionSearchItem.PatientId,
      "true",
    ]);
  }

  openLogViewDialog(admissionSearchItem: AdmissionSearchItem): void {
    const dialogRef = this.dialog.open(LogViewDialogComponent, {
      width: "50%",
      data: admissionSearchItem.MedicalAppointmentId,
    });
  }

  openMedicalAppointmentCancelDialog(
    admissionSearchItem: AdmissionSearchItem,
  ): void {
    const medicalAppointmentIds: number[] = [];
    medicalAppointmentIds.push(admissionSearchItem.MedicalAppointmentId);

    const dialogRef = this.dialog.open(
      DialogCancelMedicalAppointmentComponent,
      {
        width: "50%",
        data: { medicalAppointmentIds: medicalAppointmentIds },
      },
    );

    dialogRef.afterClosed().subscribe((result: MedicalAppointmentCancel) => {
      if (result) {
        this.searchFilter.search();
      }
    });
  }
}
